import { Folder, Tag } from "lucide-react"

import { Button } from "@/components/ui/button.tsx"
import type { TagPath } from "@/types/dataPointTypes.ts"

import { getTagPathDisplayName } from "../../util/getTagPathDisplayName.ts"

export default function TagPathDisplay({
  path,
  onSelect,
  selected,
}: {
  path: TagPath
  onSelect: (path: TagPath) => void
  selected: boolean
}) {
  return (
    <Button
      variant={selected ? "default" : "outline"}
      onClick={() => onSelect(path)}
      type="button"
      className="justify-baseline"
    >
      {path.folder ? <Folder /> : <Tag />}
      {getTagPathDisplayName(path)}
    </Button>
  )
}
